import React from "react"
import FormField from "./formField"

const TextFormField = ({
  label,
  name,
  errortext,
  registerfunc,
  errorsfunc,
}) => (
  <>
    <FormField
      name={name}
      label={label}
      type="text"
      registerfunc={registerfunc}
      errorsfunc={errorsfunc}
      // errortext={`${name} is required`}
    />
  </>
)

export default TextFormField
